<script setup lang="ts">
defineProps<{
  icon?: string
  title: string
  description?: string
}>()
</script>

<template>
  <div class="text-center py-12 px-4">
    <UIcon
      v-if="icon"
      :name="icon"
      class="w-12 h-12 text-dimmed mx-auto mb-4"
    />
    <h3 class="text-lg font-medium text-highlighted mb-2">
      {{ title }}
    </h3>
    <p v-if="description" class="text-muted max-w-md mx-auto">
      {{ description }}
    </p>
    <div v-if="$slots.default" class="mt-6">
      <slot />
    </div>
    <div v-if="$slots.actions" class="mt-6">
      <slot name="actions" />
    </div>
  </div>
</template>
